import queryCurrentUserNetworks from '@ms/yammer-graphql/dist/operations/queryCurrentUserNetworks.graphql';
import { reportError } from '@ms/yammer-telemetry';

import { GraphqlApiRequest, ManagedApiLifecycle, getGraphqlApiRequest, managedApiAction } from '../..';
import { CurrentUserNetworkList } from '../../state/types';
import { PromiseThunkAction } from '../../types';

import {
  LoadCurrentUserNetworksFulfilledAction,
  LoadCurrentUserNetworksPendingAction,
  LoadCurrentUserNetworksRejectedAction,
  LoadCurrentUserNetworksResponse,
} from './actions.types';
import { getCurrentUserNetworksStatus } from './selectors';

const loadCurrentUserNetworksPending = (): LoadCurrentUserNetworksPendingAction => ({
  type: 'CURRENT_USER.LOAD_NETWORKS_PENDING',
});

const loadCurrentUserNetworksFulfilled = (
  currentUserNetworks: CurrentUserNetworkList
): LoadCurrentUserNetworksFulfilledAction => ({
  type: 'CURRENT_USER.LOAD_NETWORKS_FULFILLED',
  payload: {
    currentUserNetworks,
  },
});

const loadCurrentUserNetworksRejected = (error: unknown): LoadCurrentUserNetworksRejectedAction => ({
  type: 'CURRENT_USER.LOAD_NETWORKS_REJECTED',
  payload: {
    error,
  },
  error: true,
});

const loadCurrentUserNetworksRequest: GraphqlApiRequest = getGraphqlApiRequest({
  body: {
    operationName: 'CurrentUserNetworksClients',
    query: queryCurrentUserNetworks,
  },
});

const loadCurrentUserNetworksLifecycle: ManagedApiLifecycle<LoadCurrentUserNetworksResponse> = {
  pending: () => loadCurrentUserNetworksPending(),
  fulfilled: (response) => loadCurrentUserNetworksFulfilled(response.data.viewer.networks.edges),
  rejected: loadCurrentUserNetworksRejected,
};

type LoadCurrentUserNetworks = () => PromiseThunkAction<void>;
export const loadCurrentUserNetworks: LoadCurrentUserNetworks = () => async (dispatch, getState) => {
  const state = getState();
  const networkStatus = getCurrentUserNetworksStatus(state);

  if (networkStatus === 'pending') {
    return;
  }

  const action = managedApiAction({
    request: loadCurrentUserNetworksRequest,
    lifecycle: loadCurrentUserNetworksLifecycle,
  });
  try {
    await dispatch(action);
  } catch (error) {
    reportError({ error });
  }
};
